import { useEffect, useMemo, useState } from 'react';
import '@/pages/home/home.css';
import SiteNav from '@/components/feature/SiteNav';
import VisitFooter from '@/pages/home/components/VisitFooter';
import { products, productCategories } from '@/mocks/products';
import CollectionOpening from './components/CollectionOpening';
import CategoryFilter from './components/CategoryFilter';
import CollectionGrid from './components/CollectionGrid';

export default function CollectionPage() {
  const [active, setActive] = useState('All');

  useEffect(() => {
    document.title = 'The Collection — FOLD. Artisan Bakery';
    document.querySelector('meta[name="description"]')?.setAttribute('content', 'The FOLD. collection: hand-laminated croissants, pastries, naturally leavened bread and seasonal bakes, made in small batches. Pickup only.');
    window.scrollTo(0, 0);
  }, []);

  const options = useMemo(
    () => [
      { key: 'All', label: 'All', count: products.length },
      ...productCategories.map((c) => ({ key: c, label: c, count: products.filter((p) => p.category === c).length })),
    ],
    [],
  );
  const items = useMemo(() => (active === 'All' ? products : products.filter((p) => p.category === active)), [active]);

  return (
    <div className="fold-home">
      <SiteNav />
      <main>
        <CollectionOpening count={products.length} />
        <CategoryFilter options={options} active={active} onChange={setActive} />
        <CollectionGrid key={active} items={items} />
        <VisitFooter />
      </main>
    </div>
  );
}